/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Grid_Not_InitializedInputs */

const en_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid not initialized`)
};

const fr_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grille non initialisée`)
};

const de_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid nicht initialisiert`)
};

const it_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griglia non inizializzata`)
};

const ru_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сетка не инициализирована`)
};

const es_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuadrícula no inicializada`)
};

const zh_cn2_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网格未初始化`)
};

const ja_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリッドが初期化されていません`)
};

const hi_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ग्रिड आरंभ नहीं हुआ`)
};

const pt_pt2_knp_terms_grid_not_initialized = /** @type {(inputs: Knp_Terms_Grid_Not_InitializedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade não inicializada`)
};

/**
* | output |
* | --- |
* | "Grid not initialized" |
*
* @param {Knp_Terms_Grid_Not_InitializedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_grid_not_initialized = /** @type {((inputs?: Knp_Terms_Grid_Not_InitializedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Grid_Not_InitializedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_grid_not_initialized(inputs)
	if (locale === "de") return de_knp_terms_grid_not_initialized(inputs)
	if (locale === "it") return it_knp_terms_grid_not_initialized(inputs)
	if (locale === "ru") return ru_knp_terms_grid_not_initialized(inputs)
	if (locale === "es") return es_knp_terms_grid_not_initialized(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_grid_not_initialized(inputs)
	if (locale === "ja") return ja_knp_terms_grid_not_initialized(inputs)
	if (locale === "hi") return hi_knp_terms_grid_not_initialized(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_grid_not_initialized(inputs)
	return en_knp_terms_grid_not_initialized(inputs)
});